export const NAME = 'usersReducer';
export const ITEM_PATH = '/users/item';
export const PAGE_TITLE_KEY = 'usersPage.table.title';
